import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import InputMask from 'react-input-mask';
import {NumericInput} from "../../Components/numeric/numericInput";
import QuestionContainer from "../../Components/questionContainer";
import AnswerContainer from "../../Components/answerContainer";
import _ from "lodash";

class PresentationTypeInput extends Component {

  constructor(props){
    super(props);
    const {detail, question} = props

    let value1 = detail && detail.value1 ? detail.value1 : false;
    let value2 = detail && detail.value2 ? detail.value2 : false;
    if (question.decimals) {
      value1 = value1 / Math.pow(10, question.decimals)
    }

    if (question.decimals) {
      value2 = value2 / Math.pow(10, question.decimals)
    }

    this.state = {
      value1: value1,
      value2: value2,
    };

    this.onChange = this.onChange.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.getInputForProperty = this.getInputForProperty.bind(this);
  }

  onChange(e, property){
    const {question} = this.props;
    let targetValue = e.target.value.replace(',', '.');
    let value = Number(targetValue * Math.pow(10, question.decimals));

    this.changeValue(value, property);
  }

  changeValue(value, property){
    const {question} = this.props;
    let number = Number(value * Math.pow(10, question.decimals));

    let {detail} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    detail = {
      ...detail,
      microTime,
      [property]: number
    };

    this.props.onDetailUpdated(detail);
  }

  //

  getInputForProperty(property) {
    const {question, detail} = this.props;
    const value = detail[property];

    return <InputMask
      type="text"
      className="mb-0 form-control text-center"
      min={question.valueMin}
      max={question.valueMax}
      step={question.step / Math.pow(10, question.decimals)}
      onFocus={e => {
        this.setState({
          [property]: ((value / Math.pow(10, question.decimals)).toFixed(question.decimals))
        });

        e.target.select();
      }}
      onBlur={e => {
        this.setState({
          [property]: false
        });

        this.onChange(e, property)
      }}
      onChange={e => {
        let value = e.target.value.replace(',', '.');

        // if (value > question.valueMax) {
        //   value = question.valueMax;
        // }

        if (value === '' || /^\d*\.?\d*$/.test(value))
          this.setState({
            [property]: value
          });
      }}
      value={this.state[property] !== false ? this.state[property] : ((value / Math.pow(10, question.decimals)).toFixed(question.decimals))}
    />;
  }

  render() {
    const {detail, question, validate} = this.props;
    const {value1, value2} = this.state;

    return <QuestionContainer
      question={question}
      component={
        <React.Fragment>
          <NumericInput
              classes={question.range ? "mb-5" : ""}
              question={question}
              isError={(!_.isNull(validate) && validate.errors.length > 0)}
              value={value1 !== false ? value1 : ((value1 / Math.pow(10, question.decimals)).toFixed(question.decimals))}
              changeValue={(value) => {
                this.setState({
                  value1: value
                });
                this.changeValue(value, 'value1');
              }}
          />
          {question.range && <NumericInput
              question={question}
              isError={(!_.isNull(validate) && validate.errors.length > 0)}
              value={value2 !== false ? value2 : ((value2 / Math.pow(10, question.decimals)).toFixed(question.decimals))}
              changeValue={(value) => {
                this.setState({
                  value2: value
                });
                this.changeValue(value, 'value2');
              }}
          />}
          {/*{question.valueText && <InputGroupAddon addonType="append" className="value-text">{question.valueText}</InputGroupAddon>}*/}
        </React.Fragment>
      }
    />
  }
}

PresentationTypeInput.propTypes = {
  detail: PropTypes.shape({
    value1: PropTypes.number,
    value2: PropTypes.number,
  }),
  question: PropTypes.shape({
    valueMin: PropTypes.number.isRequired,
    valueMax: PropTypes.number.isRequired,
    decimals: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    valueText: PropTypes.string,
    range: PropTypes.bool.isRequired
  }).isRequired,
  onDetailUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true})(PresentationTypeInput);